import { Button, Col, Input, message, Modal, Row } from "antd";
import { useState } from "react";
import API from "../../../../services/api-request";

const ImportPallet = (props) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImport = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    API.Post("pallet/upload", formData)
      .then((res) => {
        message.success("Upload file success!");
        props.onShowImport(false);
      })
      .catch((err) => {
        console.log(err);
        const errorMessage = err?.response?.data?.error;

        if (errorMessage) {
          message.error(errorMessage);
        } else {
          message.error("Failed to upload file!");
        }
      })
      .finally(() => {
        setLoading(false);
        setFile(null);
      });
  };

  const handleCancel = () => {
    props.onShowImport(false);
  };

  return (
    <Modal
      title="Import Pallet"
      open={props.showImport}
      onCancel={handleCancel}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          loading={loading}
          key="submit"
          type="primary"
          onClick={() => handleImport()}
        >
          Submit
        </Button>,
      ]}
    >
      <Row gutter={8}>
        <Col span={24}>
          <Input
            type="file"
            placeholder="Select File"
            onChange={(e) => {
              setFile(e.target.files[0]);
            }}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default ImportPallet;
